__turbopack_context__.v({
  "className": "inter_509fa2c0-module__FsZf6a__className",
});
